import $ from 'jquery';
import Scroll from './Scroll/_Scroll';
import Nav from './Nav/_Nav';
import Page from './Page/_State';

(() => {
  $(window).on('load', function () {
    // 強制的にページトップ
    setTimeout(function () {
      $('html,body').scrollTop(0);
      // SPナビクラスを実行
      new Nav($('.nav'));
      $('.loading').fadeOut();
    }, 1000);

    // setTimeout(function () {
    //   // new Parallax();
    // }, 2000);

    // マジックスクロールを実行
    Scroll.ins.setController();
  });
})();
